export default class WebComponent {
    constructor(el, params) {
        this.element = el
        this.params = params

        this.init()
    }
}